import { createFileRoute } from "@tanstack/react-router";

import { PlatformAdminApp } from "../components/admin/PlatformAdminApp";

export const Route = createFileRoute("/admin")({
  component: PlatformAdminApp,
});
